import { render, staticRenderFns } from "./RoomNumberMessage.vue?vue&type=template&id=61eeb00c&scoped=true&"
import script from "./RoomNumberMessage.vue?vue&type=script&lang=js&"
export * from "./RoomNumberMessage.vue?vue&type=script&lang=js&"
import style0 from "./RoomNumberMessage.vue?vue&type=style&index=0&id=61eeb00c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61eeb00c",
  null
  
)

export default component.exports